export default __webpack_public_path__ + "static/media/brij.1fec35fa.svg";